export const UPDATEBASICPICKUPTIME = 'UPDATEBASICPICKUPTIME';
export const UPDATEBRANCHDELAYTIME = 'UPDATEBRANCHDELAYTIME';
export const UPDATE_PICKUP_DELAY = 'UPDATE_PICKUP_DELAY';
export const UPDATE_BASIC_PICKUP_TIME_AND_DELAY =
  'UPDATE_BASIC_PICKUP_TIME_AND_DELAY';
export const UPDATE_FROM = 'UPDATE_FROM';
export const UPDATE_MANUAL_PICKUP_TIME_SETUP =
  'UPDATE_MANUAL_PICKUP_TIME_SETUP';

export const updateBasicPickupTime = (basicPickupTime) => ({
  type: UPDATEBASICPICKUPTIME,
  basicPickupTime,
});

export const updateBranchDelayTime = (delayData) => ({
  type: UPDATEBRANCHDELAYTIME,
  delayData,
});

export const updatePickupDelay = (pickupDelay) => ({
  type: UPDATE_PICKUP_DELAY,
  pickupDelay,
});

export const updateBasicPickupTimeAndDelay = (BasicPickupTimeAndDelay) => ({
  type: UPDATE_BASIC_PICKUP_TIME_AND_DELAY,
  payload: BasicPickupTimeAndDelay,
});

export const updateFrom = (updateFromServer) => ({
  type: UPDATE_FROM,
  payload: updateFromServer,
});

export const updateManualPickupTimeSetup = (updateManualPickupTimeSetup) => ({
  type: UPDATE_MANUAL_PICKUP_TIME_SETUP,
  payload: updateManualPickupTimeSetup,
});
